const createAnimationState = (set) => ({
  animationReady: false,
  setAnimationReady: () => set({ animationReady: true }),

  animationRunning: false,
  setAnimationRunning: (newR) => set({ animationRunning: newR }),
});

export { createAnimationState };
